import { render, staticRenderFns } from "./ComponentRootTagWarning.vue?vue&type=template&id=20a5fb30&scoped=true&"
import script from "./ComponentRootTagWarning.vue?vue&type=script&lang=ts&"
export * from "./ComponentRootTagWarning.vue?vue&type=script&lang=ts&"
import style0 from "./ComponentRootTagWarning.vue?vue&type=style&index=0&id=20a5fb30&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a5fb30",
  null
  
)

export default component.exports